<select
  id="scale"
  [ngClass]="{
    'top': toolsService.navigationOnTop,
    'events-open': displayCloseEventsButton()
  }"
  [(ngModel)]="scale"
  (change)="setScale()">
  <option value="10000" selected>1:10000000</option>
  <option value="1000">1:1000000</option>
  <option value="100">1:100000</option>
  <option value="10">1:10000</option>
  <option value="1">1:1000</option>
</select>
